/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocument {
    getFixupPrototypeFunction() { return AwsSsmDocument.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocument>): AwsSsmDocument {
        let obj = Object.assign(new AwsSsmDocument(), model);
        AwsSsmDocument.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocument>): AwsSsmDocument {
        if (!model) return null;
        return AwsSsmDocument.newInstance(<AwsSsmDocument> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocument) {
        if (!obj) return;

        models.AwsSsmDocument.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocument): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocument.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.document_creation_time === "string") {
            this.document_creation_time = new Date(<string><any>this.document_creation_time);
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.permission_details) {
            models.AwsSsmDocumentPermissionDetail.fixupPrototype(this.permission_details);
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.AwsSsmDocumentTag.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of the document.
     */
    sysId: string;

    /**
     * Name of the document.
     */
    name: string;

    /**
     * Category of the document.
     */
    categories: Array<string>;

    /**
     * Type of the document.
     */
    document_type: string;

    /**
     * Owner of the document.
     */
    owner: string;

    /**
     * Platform of the document can be executed.
     */
    os_types: Array<string>;

    /**
     * Scope of the SSM document.
     */
    scope: string;

    /**
     * For private, self type of documents the cloud account id will be mapped
     */
    cloud_account_id: string;

    /**
     * For non global document region based mapping will be there
     */
    region: string;

    /**
     * Time of document creation
     */
    document_creation_time: Date;

    /**
     * Latest version of the document
     */
    latest_version: string;

    /**
     * The default version
     */
    default_version: string;

    /**
     * Current document version that is viewing
     */
    document_version: string;

    /**
     * Status of the document
     */
    status: models.AwsSsmAutomationDocumentStatus;

    /**
     * Tag key and Value pair available for the document
     */
    tags: Array<models.AwsSsmDocumentTag>;

    /**
     * Permission details of the Document.
     */
    permission_details: models.AwsSsmDocumentPermissionDetail;

    /**
     * Time of the document synced with system.
     */
    created_at: Date;

    /**
     * last synced time of the document.
     */
    updated_at: Date;

}
